/**
 * Normalizes orders report API payloads.
 * Supports both:
 * 1) { status, data: Row[], pagination/meta }
 * 2) Laravel paginator-like objects
 */
export function normalizeOrderReportTablePayload(payload) {
  const p = payload || {};

  if (Array.isArray(p.data)) {
    const pag = p.pagination || p.meta || {};
    return {
      data: p.data,
      total: pag.total ?? 0,
      per_page: pag.perPage ?? pag.per_page ?? 10,
      current_page: pag.page ?? pag.current_page ?? pag.currentPage ?? 1,
    };
  }

  const inner = p.data && typeof p.data === 'object' && !Array.isArray(p.data) ? p.data : p;
  return {
    ...inner,
    data: Array.isArray(inner?.data) ? inner.data : [],
    total: inner.total ?? 0,
    per_page: inner.per_page ?? inner.perPage ?? 10,
    current_page: inner.current_page ?? inner.currentPage ?? inner.page ?? 1,
  };
}

export function normalizeOrderReportSeriesPayload(payload) {
  const p = payload || {};
  if (Array.isArray(p.series)) return p.series;
  if (Array.isArray(p?.data?.series)) return p.data.series;
  if (Array.isArray(p?.summary?.series)) return p.summary.series;
  if (Array.isArray(p?.data)) return [];
  return [];
}

export function normalizeOrderReportSummaryPayload(payload) {
  const p = payload || {};
  if (p.summary && typeof p.summary === 'object') return p.summary;
  if (p?.data?.summary && typeof p.data.summary === 'object') return p.data.summary;
  if (p?.data && typeof p.data === 'object' && !Array.isArray(p.data)) return p.data;
  return {};
}

